import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as results from "./style.module.scss";
export const Results = () => {
  return (
    <section className={results.results}>
      <div className={results.results__wrapper}>
        <div className="container">
          <h2 className={`${main.mainTitle} ${results.results__title}`}>Результаты курса</h2>
          <ul className={results.results__list}>
            <li className={`${results.results__item} ${results.results__item1}`}>
              <div className={results.results__itemHeader}>
                <div className={results.results__itemTitle}>
                  Знание
                </div>
              </div>
              <div className={results.results__itemBody}>
                <ul className={results.results__itemList}>
                  <li>Принципов тайм-менеджмента;</li>
                  <li>Свойств времени;</li>
                  <li>Внутренних препятствий, мешающих эффективной работе;</li>
                  <li>Внешних помех, «ворующих время».</li>
                </ul>
              </div>
            </li>

            <li className={`${results.results__item} ${results.results__item2}`}>
              <div className={results.results__itemHeader}>
                <div className={results.results__itemTitle}>
                  Умение
                </div>
              </div>
              <div className={results.results__itemBody}>
                <ul className={results.results__itemList}>
                  <li>Распознавать «убийц времени» (внешних и внутренних);</li>
                  <li>Распределять дела;</li>
                  <li>Управлять рабочим и личным временем;</li>
                  <li>Успевать больше и уставать меньше.</li>
                </ul>
              </div>
            </li>

            <li className={`${results.results__item} ${results.results__item3}`}>
              <div className={results.results__itemHeader}>
                <div className={results.results__itemTitle}>
                  Владение
                </div>
              </div>
              <div className={results.results__itemBody}>
                <ul className={results.results__itemList}>
                  <li>Грамотным планированием;</li>
                  <li>Инструментами приоритизации задач;</li>
                  <li>Тренажером для поддержания своей эффективности.</li>
                </ul>
              </div>
            </li>
          </ul>
          <a className={main.mainBtn} href="#widget">Начать учиться</a>
        </div>
      </div>
    </section>
  );
};
